import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class TaxGet extends PlusComponent {
  constructor(props) {
    super(props, "contentTax");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentTax"></ContentSettings>
        </div>
      )
    }
}

export default TaxGet;